import m from "mithril";
import {InputTextItem} from '../../model/items/inputText'

export function inputTextItemView(c:InputTextItem) {
	return c.isVisible() ? m('span[class=input-text]', [
		m('span[class=input-text-text]', m.trust(c.questionary.renderText(c.text))),
		m('textarea.auto-size', {
            autocomplete: 'off',
			value: c.getVariable() || "",
			// stop the click event, so it will not get propagated to parent checkbox / radio
			oncreate: (vnode) => {
                const textarea = <HTMLInputElement>vnode.dom;
                const onInput = () => {
                    textarea.style.height = 'auto';
                    textarea.style.height = '0px';
                    textarea.style.height = textarea.scrollHeight + 'px';
                    c.set(textarea.value);
                };
                textarea.setAttribute('style', 'height:' + (textarea.scrollHeight) + 'px;overflow-y:hidden;');
                textarea.addEventListener("input", onInput, false);

                textarea.addEventListener('click', e => {
                    e.stopPropagation();
                    e.preventDefault();
                }, true);

                onInput();
            }
		})
	]) : null;
}
